
/**
 * Object representing the Brazilian zip code validation.
 * @typedef {Object} BR
 * @property {RegExp} regex - Regular expression for validating the zip code.
 * @property {function} validate - Function to validate a given zip code value.
 */
const BR = {
  regex: /^[0-9]{5}-?[0-9]{3}$/,
  validate: (value) => {
    if (typeof value !== 'string') {
      return false
    }

    if (!validators.BR.regex.test(value)) {
      return false
    }

    return true
  }
}

/**
 * Represents the zip code validation for Mexico.
 * @type {Object}
 * @property {RegExp} regex - The regular expression used to validate the zip code.
 * @property {Function} validate - The validation function that checks if the given value is a valid zip code.
 * @param {string} value - The value to be validated.
 * @returns {boolean} - Returns true if the value is a valid zip code, otherwise false.
 */
const MX = {
  regex: /^\d{5}$/,
  validate: (value) => {
    if (typeof value !== 'string') {
      return false
    }

    if (!validators.MX.regex.test(value)) {
      return false
    }

    return true
  }
}

/**
 * Object containing validators for zip codes.
 * @type {Object}
 */
const validators = {
  BR,
  MX
}

/**
 * Validates a zip code based on the country.
 *
 * @param {string} country - The country code.
 * @param {string} value - The zip code value to validate.
 * @returns {boolean} - Returns true if the zip code is valid, otherwise false.
 */
export const validateZipCode = (country, value) => {
  if (validators[country]) {
    const validator = validators[country]
    return validator.validate(value)
  }

  return true
}

export default {
  validators,
  validateZipCode
}
